const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,

  ADMIN: {
    LOGIN: "/admin/login",
    REGISTER: "/admin/register",
    ONBOARDING_STATUS: "/admin/onboarding-status",
    PROFILE_SETUP: "/admin/profile-setup",
    PROFILE: "/admin/profile",
    PATIENTS: "/admin/patients",
    MATCH_WORKERS: (patientID) => `/admin/match-workers/${patientID}`,
    DELETE_PATIENT: (patientID) => `/admin/patient/${patientID}`,
    DELETE_WORKER: (workerID) => `/admin/worker/${workerID}`,
    DOCUMENT_UPLOAD: "/admin/documents/upload",
    DOCUMENT_LIST: "/admin/documents",
    DOCUMENT_DELETE: (id) => `/admin/documents/${id}`,
    DOCUMENT_QUERY: "/admin/documents/query",
    DOCUMENT_STATS: "/admin/documents/stats",
    DOCUMENT_CHAT_SESSION: "/admin/documents/sessions",
    DOCUMENT_CHAT_MESSAGES: (sessionId) =>
      `/admin/documents/sessions/${encodeURIComponent(sessionId)}/messages`,
    SPEECH_TO_TEXT: "/api/speech-to-text",
    TEXT_TO_SPEECH: "/api/text-to-speech"
  },

  PATIENT: {
    LOGIN: "/patient/login",
    REGISTER: "/patient/register",
    PROFILE: "/patient/profile",
    PROFILE_PICTURE: "/patient/profile-picture"
  },

  WORKER: {
    LOGIN: "/worker/login",
    REGISTER: "/worker/register",
    STATUS: "/worker/status",
    PROFILE: "/worker/profile",
    ELDER_PROFILE: (patientId) =>
      `/worker/patients/${encodeURIComponent(patientId)}/profile`
  },

  WORKER_AGENTS: {
    LIST: "/worker/agents",
    IMPORT: "/worker/agents/import",
    DETAIL: (slug) => `/worker/agents/${encodeURIComponent(slug)}`,
    DELETE: (slug) => `/worker/agents/${encodeURIComponent(slug)}`,
    CHAT_THREADS: "/worker/agents/chat/threads",
    DELETE_THREAD: "/worker/agents/chat/threads",
    CHAT_HISTORY: "/worker/agents/chat/history",
    CHAT_RUN: "/worker/agents/chat/run"
  },

  AI: {
    PATIENT_PROFILE_DOCUMENT: (patientID) =>
      `/ai/patient/${patientID}/profile-document`
  },

  AGENTS: {
    LIST: "/agents",
    IMPORT: "/agents/import",
    DETAIL: (slug) => `/agents/${encodeURIComponent(slug)}`,
    DELETE: (slug) => `/agents/${encodeURIComponent(slug)}`,
    CHAT_THREADS: "/agents/chat/threads",
    DELETE_THREAD: "/agents/chat/threads",
    CHAT_HISTORY: "/agents/chat/history",
    CHAT_RUN: "/agents/chat/run"
  }
};

export default config;

